import type React from 'react';
import { type DrawerContentProps } from '../state';
import {
  AddContributorsDrawer,
  DemoDrawer,
  DeleteEventDrawer,
  CreateMemberDrawer,
  InviteMemberDrawer,
  ViewMemberDrawer,
  DeleteMemberDrawer,
  EditIncidentDrawer,
  EditEventDrawer,
  CreateEventDrawer,
  EmbedEventDrawer,
  FileUploadDrawer,
} from './drawers';

const Noop = () => null;

const DRAWERS: Record<string, React.FC<DrawerContentProps>> = {
  addContributors: AddContributorsDrawer,
  demo: DemoDrawer,
  deleteEvent: DeleteEventDrawer,
  createMember: CreateMemberDrawer,
  inviteMember: InviteMemberDrawer,
  viewMember: ViewMemberDrawer,
  deleteMember: DeleteMemberDrawer,
  editIncident: EditIncidentDrawer,
  editEvent: EditEventDrawer,
  createEvent: CreateEventDrawer,
  embedEvent: EmbedEventDrawer,
  fileUpload: FileUploadDrawer,
};

export const getDrawerContent = (
  drawerType: string | null,
): React.FC<DrawerContentProps> => DRAWERS[drawerType || ''] || Noop;
